import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function Binocular(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M49.233339,61.3333333 L42.766661,61.3333333 L42.1099941,63.7840475
          C39.6185173,73.0823657 30.0609999,78.600401 20.7626816,76.1089241
          C11.4643633,73.6174472 5.94632811,64.0599298 8.43780498,54.7616116
          L15.0299905,30.1592402 C17.5214674,20.860922 27.0789847,15.3428867
          36.377303,17.8343636 C40.411662,18.9153668 43.7343741,21.3265684
          46,24.46965 C48.2656259,21.3265684 51.588338,18.9153668 55.622697,17.8343636
          C64.9210153,15.3428867 74.4785326,20.860922 76.9700095,30.1592402
          L83.562195,54.7616116 C86.0536719,64.0599298 80.5356367,73.6174472
          71.2373184,76.1089241 C61.9390001,78.600401 52.3814827,73.0823657
          49.8900059,63.7840475 L49.233339,61.3333333 L49.233339,61.3333333 Z"
      />
      <path
        d="M66.9160092,69.4032148 C72.6918057,69.4032148 77.3740138,64.5448875
          77.3740138,58.551837 C77.3740138,52.5587866 72.6918057,47.7004593 66.9160092,47.7004593
          C61.1402128,47.7004593 56.4580046,52.5587866 56.4580046,58.551837 C56.4580046,64.5448875
          61.1402128,69.4032148 66.9160092,69.4032148 Z"
        fill="white"
      />
      <path
        d="M25.0839908,69.4032148 C30.8597872,69.4032148 35.5419954,64.5448875
          35.5419954,58.551837 C35.5419954,52.5587866 30.8597872,47.7004593 25.0839908,47.7004593
          C19.3081943,47.7004593 14.6259862,52.5587866 14.6259862,58.551837 C14.6259862,64.5448875
          19.3081943,69.4032148 25.0839908,69.4032148 Z"
        fill="white"
      />
    </SvgIcon>
  );
}
